// extracted by mini-css-extract-plugin
export default {"appContainer":"layouts_appContainer__SV+H0","main":"layouts_main__cdi8W","content":"layouts_content__808OR"};